import { VStack, Text, Heading, Divider, SimpleGrid, HStack, Image } from '@chakra-ui/react'

import { useFormikContext } from 'formik'
import React from 'react'
import { AddPropertyValues } from '.'
import { ConnectedSwitch } from 'components/FormElements'
import moment from 'moment'
import { DATE_FORMAT } from '../../../../constants'
import { Maybe, UploadFile, Agent } from 'generated/graphql'
import { useGeolocation } from 'hooks'
import AgentCard from 'components/Property/Admin/Listings/AgentCard'
import { useTranslation } from 'react-i18next'
import { useAuthContext } from 'context/AuthProvider'
import { amountFormatter } from 'utils'

const Summary: React.FC<{
  isTabletOrMobile?: boolean
  photos?: Maybe<Maybe<UploadFile>[]> | undefined
}> = ({ isTabletOrMobile, photos }) => {
  const { values } = useFormikContext<AddPropertyValues>()
  const { t } = useTranslation()
  const { isAgent } = useAuthContext()
  const { currency } = useGeolocation()
  return (
    <>
      <VStack spacing={8} my={10} alignItems="flex-start">
        <Heading>Summary</Heading>

        <SimpleGrid rowGap={0} fontSize="sm" columnGap={4} columns={isTabletOrMobile ? 0 : 2}>
          <Text>
            Occupation date: <b>{moment(values.Occupation_date).format(DATE_FORMAT)}</b>
          </Text>
          <Text>
            Lease period: <b>{values.Lease_period}</b>
          </Text>
          <Text>
            Street address: <b>{values.Street_address}</b>
          </Text>

          <Text>
            Price: <b>{amountFormatter(parseInt(values?.Price) || 0, currency)}</b>
          </Text>

          <Text>
            Bathrooms: <b>{values.Bathrooms}</b>
          </Text>
          <Text>
            Bedrooms: <b>{values.Bedrooms}</b>
          </Text>
          <Text>
            Kitchens: <b>{values.Kitchens}</b>
          </Text>
          <Text>
            Lounges: <b>{values.Lounges}</b>
          </Text>
          <Text>
            Dining rooms: <b>{values.Dining_rooms}</b>
          </Text>
          <Text>
            Parking: <b>{values.Parking}</b>
          </Text>
          <Text>
            Floor size:{' '}
            <b>
              {values.Floor_size}m
              <Text as="sup" fontSize="xs">
                2
              </Text>
            </b>
          </Text>
          <Text>
            Furnished: <b>{values.Furnished ? t('yes') : t('no')}</b>
          </Text>
          <Text>
            Pool: <b>{values.Pool ? t('yes') : t('no')}</b>
          </Text>
          <Text>
            Description: <b>{values.Description}</b>
          </Text>
        </SimpleGrid>

        {photos?.length !== 0 && (
          <>
            <Heading size="md">Images</Heading>

            <HStack overflowX="auto" overflowY="hidden">
              {photos?.map((image, index) => (
                <Image
                  key={index}
                  src={image?.formats?.thumbnail?.url || image?.url || ''}
                  alt="property"
                  rounded="md"
                  width="100px"
                />
              ))}
              {values.images?.length !== 0 &&
                values.images?.map((image, index) => (
                  <Image
                    key={index}
                    src={URL.createObjectURL(image?.file)}
                    alt="property"
                    rounded="md"
                    width="100px"
                  />
                ))}
            </HStack>
          </>
        )}
      </VStack>
      <Divider my={10} />

      <ConnectedSwitch name="Publish_state" label="Publish Property" />

      {!isAgent && <AgentCard agent={values?.agent as Agent} mt={8} isMobile />}
    </>
  )
}

export default Summary
